import React from 'react'

interface IconProps {
  size?: number
  className?: string
  style?: React.CSSProperties
}

type SVGProps = { width: number; height: number; fill: string; stroke: string; strokeLinecap: 'round'; strokeLinejoin: 'round'; strokeWidth: string; className?: string; style?: React.CSSProperties }

function svg(size: number, sw: string, className?: string, style?: React.CSSProperties): SVGProps {
  return { width: size, height: size, fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: sw, className, style }
}

export const Icons = {
  pin: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M12 21s-7-7.5-7-12a7 7 0 1 1 14 0c0 4.5-7 12-7 12Z"/>
      <circle cx="12" cy="9" r="2.5"/>
    </svg>
  ),
  search: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <circle cx="11" cy="11" r="7"/>
      <path d="m20 20-3.5-3.5"/>
    </svg>
  ),
  cal: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5"/>
      <path d="M8 3v4M16 3v4M3.5 10h17"/>
    </svg>
  ),
  clock: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <circle cx="12" cy="12" r="8.5"/>
      <path d="M12 7.5V12l3 2"/>
    </svg>
  ),
  lock: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <rect x="5" y="11" width="14" height="9" rx="2"/>
      <path d="M8 11V8a4 4 0 1 1 8 0v3"/>
    </svg>
  ),
  arrow: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="M5 12h14M13 6l6 6-6 6"/>
    </svg>
  ),
  chevron: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="m9 6 6 6-6 6"/>
    </svg>
  ),
  back: ({ size = 18, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="M15 6 9 12l6 6"/>
    </svg>
  ),
  users: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <circle cx="9" cy="9" r="3.5"/>
      <path d="M2.5 19c.8-3 3.5-4.5 6.5-4.5s5.7 1.5 6.5 4.5"/>
      <circle cx="17" cy="7.5" r="2.5"/>
      <path d="M16 14.5c2.5.2 4.4 1.7 5 4"/>
    </svg>
  ),
  plus: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="M12 5v14M5 12h14"/>
    </svg>
  ),
  minus: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="M5 12h14"/>
    </svg>
  ),
  map: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M3 6.5 9 4l6 2 6-2.5v14L15 20l-6-2-6 2.5v-14Z"/>
      <path d="M9 4v16M15 6v14"/>
    </svg>
  ),
  sliders: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M4 7h10M18 7h2M4 17h2M10 17h10"/>
      <circle cx="16" cy="7" r="2"/>
      <circle cx="8" cy="17" r="2"/>
    </svg>
  ),
  check: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '2', className, style)}>
      <path d="m5 12 5 5 9-11"/>
    </svg>
  ),
  x: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.8', className, style)}>
      <path d="m6 6 12 12M18 6 6 18"/>
    </svg>
  ),
  spark: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.5', className, style)}>
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6 6l2 2M16 16l2 2M6 18l2-2M16 8l2-2"/>
    </svg>
  ),
  church: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M4 21V11l8-6 8 6v10"/>
      <path d="M9 21v-5h6v5M12 5V2M10 3.5h4"/>
    </svg>
  ),
  globe: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <circle cx="12" cy="12" r="9"/>
      <path d="M12 3c-2.5 3.5-4 6-4 9s1.5 5.5 4 9M12 3c2.5 3.5 4 6 4 9s-1.5 5.5-4 9M3 12h18"/>
    </svg>
  ),
  link: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  ),
  home: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M4 11 12 4l8 7v9a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1Z"/>
    </svg>
  ),
  bowl: ({ size = 16, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <path d="M3 11h18a9 9 0 0 1-18 0Z"/>
      <path d="M12 11a4 4 0 0 1 4-4M9 5c0 1.5 1 2 1 3"/>
    </svg>
  ),
  share: ({ size = 14, className, style }: IconProps) => (
    <svg viewBox="0 0 24 24" {...svg(size, '1.6', className, style)}>
      <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
  ),
}
